import ModalShareProfile from './ModalShareProfile';

export default ModalShareProfile;
